import { Link } from 'react-router-dom';
import { formatOperationalDate } from '../../utils/openingBalanceDate';

/**
 * Header chip for the current operational date. Parses Y-m-d and d-m-Y without moment Invalid date.
 */
export default function OperationalDateChip({ value, to = '/operational-dates' }) {
  const label = formatOperationalDate(value);

  return (
    <li className="nav-item d-flex align-items-center">
      <Link className="op-date-chip" to={to} title="Change operational date">
        <i className="fa fa-calendar" aria-hidden="true" />
        <span className="op-date-chip-copy">
          <span className="op-date-chip-label">Operational date</span>
          <strong>{label || 'Not set'}</strong>
        </span>
      </Link>
    </li>
  );
}
